import React from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { connectStream, compose } from '../../lib/bastetjs/utils/connectStream'
import { EventResultsStreams } from '../../data/EventResultsStreams'
import { getTokenRacerId } from '../../utils/isLoggedIn'
import { getAthleteRacesStream } from '../../data/AthleteStreams'
import { useGetEventCoursesQuery } from "../../api/alaskaApi"
import { getFollowersStream } from '../../data/ProfileStreams'
import { getFinisherCertificateUrl } from '../../data/FinisherCertificateApi'
import { getPendingClaims } from '../../data/UnclaimedSearchStreams'
import { getEntryDetail } from '../../data/VRStreams'
import { IRPBodyContainerComponent } from '../../components/IRP/body/IRPBodyContainer'
import { ReigniteIndividualSseResult } from './ReigniteIndividualSseResult'
import { RtkQueryIndividualResult } from './RtkQueryIndividualResult'

const PureIRPResult = (props: any) => {
  console.debug('PureIRPResult', props)
  const athlinksEventId = props.event?.athlinksId
  const { data: eventCourses } = useGetEventCoursesQuery(athlinksEventId, {
    skip: !athlinksEventId
  })
  if (props.useSse) {
    const bib = props.bib
    const entryId = props.entryId
    const eventCourseId = props.race?.eventCourseId
    if (props.isLive) {
      const ctliveEventId = props.event?.ctliveId
      const ctliveRaceId = props.irpResult?.raceId
      if (ctliveEventId && ctliveRaceId) {
        return <ReigniteIndividualSseResult
          {...props}
          athlinksEventId={athlinksEventId}
          courses={eventCourses}
          ctliveEventId={ctliveEventId}
          ctliveRaceId={ctliveRaceId}
          eventCourseId={eventCourseId}
        />
      }
    }
    return <RtkQueryIndividualResult
      {...props}
      athlinksEventId={athlinksEventId}
      courses={eventCourses}
      eventCourseId={eventCourseId}
      bib={bib}
      entryId={entryId}
    />
  }
  return <IRPBodyContainerComponent
    {...props}
    courses={eventCourses}
    result={props.irpResult}
  />
}

const mapStateToProps = (state: any, props: any) => ({
  dispatch: undefined,
  eventMetadata: state.eventMetadata,
  irpResult: state.irpResult?.data || props.irpResult,
  mapTracking: state.mapTracking,
  media: state.media.media,
  mediaArgs: state.media.args,
  mediaIsLoading: state.media.isLoading,
  unitType: state.userPrefs.globalUnitType,
});

export const IRPResult = compose(
  connect(mapStateToProps),
  withTranslation(),
  connectStream({
    friends: () => getFollowersStream('followers', getTokenRacerId()),
    splitsContent: () => EventResultsStreams.getLegacyEntryResult(),
    certificateUrl: ({ irpResult }: any) => getFinisherCertificateUrl(irpResult.entryId, irpResult.thirdPartyEntryId),
    pendingClaims: getPendingClaims,
    athleteRaces: () => getAthleteRacesStream(getTokenRacerId()),
    entryDetail: ({ irpResult }: any) => getEntryDetail({
      eventCourseId: irpResult.eventCourseId,
      racerId: irpResult.racerId,
      entryUniqueId: irpResult.entryUniqueId,
    }),
  })
)(PureIRPResult);
